import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const PartnerMarginModalStyles = styled.div`
  margin: ${token('space.100')};
  .dynamic-result-table-wrapper {
    padding: 0;
    table {
      border-block-end: none;
      thead {
        th:nth-child(n + 3) {
          text-align: right;
        }
      }
      tbody {
        td:nth-child(n + 3) {
          text-align: right;
        }
      }
    }
  }
`;

interface ViewDetailsButtonProps {
  isDesignIteration1Enabled: boolean;
}

export const ViewDetailsButton = styled.div<ViewDetailsButtonProps>`
  margin-left: ${(props) => !props.isDesignIteration1Enabled && '-12px'};
  margin: ${(props) => props.isDesignIteration1Enabled && '0'};
  button {
    color: ${(props) => props.isDesignIteration1Enabled && token('color.link')};
    font-weight: ${(props) => props.isDesignIteration1Enabled && '400'};
    padding: ${(props) => props.isDesignIteration1Enabled && '0'};
    > span {
      margin: ${(props) => props.isDesignIteration1Enabled && '0'};
    }
  }
`;
